<template>
  <div class="col-12">
    <div class="rankings-scroll-container">
      <!-- Main Pillars Row - All 8 Pillars -->
      <div class="row no-gutters first-row">
        <CityRanking
          :pillar-data="getCityData.people_centricity"
          :top-three="topThreePillar"
          scoreField="People Centricity"
          pillarType="people_centricity"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.openness"
          :top-three="topThreePillar"
          scoreField="Openness"
          pillarType="openness"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.sustainability"
          :top-three="topThreePillar"
          scoreField="Sustainability"
          pillarType="sustainability"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.institutions_governance"
          :top-three="topThreePillar"
          scoreField="Institutions & Governance"
          pillarType="institutions_governance"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.transport_infrastructure"
          :top-three="topThreePillar"
          scoreField="Transport & Infrastructure"
          pillarType="transport_infrastructure"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.innovation"
          :top-three="topThreePillar"
          scoreField="Innovation"
          pillarType="innovation"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.vibrancy"
          :top-three="topThreePillar"
          scoreField="Vibrancy"
          pillarType="vibrancy"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.e_intelligence"
          :top-three="topThreePillar"
          scoreField="e-Readiness"
          pillarType="e_intelligence"
          :is-first-row="true"
          :col-size="1"
        ></CityRanking>
      </div>

      <!-- Sub-pillars Row 1 - First sub-pillar for each pillar -->
      <div class="row no-gutters">
        <CityRanking
          :pillar-data="getCityData.liveability"
          :top-three="topThreePillar"
          scoreField="Liveability"
          pillarType="people_centricity"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.investment_openness"
          :top-three="topThreePillar"
          scoreField="Investment Openness"
          pillarType="openness"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.urban_design"
          :top-three="topThreePillar"
          scoreField="Urban Design"
          pillarType="sustainability"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.institutions"
          :top-three="topThreePillar"
          scoreField="Institutions"
          pillarType="institutions_governance"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.mobility"
          :top-three="topThreePillar"
          scoreField="Mobility"
          pillarType="transport_infrastructure"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.rd_intensity"
          :top-three="topThreePillar"
          scoreField="R&D Intensity"
          pillarType="innovation"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.financial_activity"
          :top-three="topThreePillar"
          scoreField="Financial Activity"
          pillarType="vibrancy"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.data_readiness"
          :top-three="topThreePillar"
          scoreField="Data Readiness"
          pillarType="e_intelligence"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
      </div>

      <!-- Sub-pillars Row 2 - Second sub-pillar for each pillar -->
      <div class="row no-gutters">
        <CityRanking
          :pillar-data="getCityData.access_to_services"
          :top-three="topThreePillar"
          scoreField="Access to Services"
          pillarType="people_centricity"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.talent_competitiveness"
          :top-three="topThreePillar"
          scoreField="Talent Competitiveness"
          pillarType="openness"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.energy_waste"
          :top-three="topThreePillar"
          scoreField="Energy & Waste"
          pillarType="sustainability"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.governance"
          :top-three="topThreePillar"
          scoreField="Governance"
          pillarType="institutions_governance"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.digital_infrastructure"
          :top-three="topThreePillar"
          scoreField="Digital Infrastructure"
          pillarType="transport_infrastructure"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.ip_intensity"
          :top-three="topThreePillar"
          scoreField="IP Intensity"
          pillarType="innovation"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.cultural_vibrancy"
          :top-three="topThreePillar"
          scoreField="Cultural Vibrancy"
          pillarType="vibrancy"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
        <CityRanking
          :pillar-data="getCityData.ai_readiness"
          :top-three="topThreePillar"
          scoreField="AI Readiness"
          pillarType="e_intelligence"
          :is-sub-pillar="true"
          :col-size="1"
        ></CityRanking>
      </div>
    </div>

    <!-- Color Legend -->
    <div class="container colour-legend-container">
      <div class="row">
        <div class="col text-center">
          <div class="m-a text-center">
            <div class="Human_Capital colour-legend green"></div>
            <div class="technology colour-legend green"></div>
            <div class="Competitiveness colour-legend green"></div>
          </div>
          <div class="row">
            <div class="col"><p>Top Performing Areas</p></div>
          </div>
        </div>
        <div class="col text-center">
          <div class="m-a text-center">
            <div class="Human_Capital colour-legend yellow"></div>
            <div class="technology colour-legend yellow"></div>
            <div class="Competitiveness colour-legend yellow"></div>
          </div>
          <div class="row">
            <div class="col"><p>Room for improvement</p></div>
          </div>
        </div>
        <div class="col text-center">
          <div class="m-a text-center">
            <div class="Human_Capital colour-legend red"></div>
            <div class="technology colour-legend red"></div>
            <div class="Competitiveness colour-legend red"></div>
          </div>
          <div class="row">
            <div class="col"><p>Requires Attention</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CityRanking from "./CityRanking";

export default {
  name: "CityRankings",
  components: { CityRanking },
  props: {
    cityRankings: {
      type: Object,
    },
    selectedCity: {
      type: String,
    },
  },
  computed: {
    getCityData() {
      return this.cityRankings[this.selectedCity] || {};
    },
    topThreePillar() {
      const cityData = this.cityRankings[this.selectedCity];
      if (!cityData) return [];

      // Get all sub-pillar rankings
      const rankings = {
        liveability: cityData.liveability?.rank || 999,
        access_to_services: cityData.access_to_services?.rank || 999,
        investment_openness: cityData.investment_openness?.rank || 999,
        talent_competitiveness: cityData.talent_competitiveness?.rank || 999,
        urban_design: cityData.urban_design?.rank || 999,
        energy_waste: cityData.energy_waste?.rank || 999,
        institutions: cityData.institutions?.rank || 999,
        governance: cityData.governance?.rank || 999,
        mobility: cityData.mobility?.rank || 999,
        digital_infrastructure: cityData.digital_infrastructure?.rank || 999,
        rd_intensity: cityData.rd_intensity?.rank || 999,
        ip_intensity: cityData.ip_intensity?.rank || 999,
        financial_activity: cityData.financial_activity?.rank || 999,
        cultural_vibrancy: cityData.cultural_vibrancy?.rank || 999,
        data_readiness: cityData.data_readiness?.rank || 999,
        ai_readiness: cityData.ai_readiness?.rank || 999,
      };

      // Convert to sortable array
      var sortable = [];
      for (var pillar in rankings) {
        sortable.push([pillar, rankings[pillar]]);
      }

      // Sort by rank (ascending - best ranks first)
      const sortedRankings = sortable.sort(function (a, b) {
        return a[1] - b[1];
      });

      // Return top 3 performing areas
      return sortedRankings.slice(0, 3);
    },
  },
};
</script>
<style scoped>
.rankings-scroll-container {
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1rem;
}

.rankings-scroll-container .row {
  flex-wrap: nowrap;
  min-width: 1600px; /* 8 columns × 200px */
}

.ranking-stat-box-header {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  background: #4a4a4a;
  margin: 0;
  min-height: 90px;
  color: white;
  border: 0.1rem solid #ffffff !important;
}

.ranking-stat-box-header p {
  font-size: 12px;
}

.ranking-stat-box-header .field-value {
  font-size: large;
}

.colour-legend {
  height: 25px;
  width: 25px;
  margin: 2px;
  border-radius: 100%;
  display: inline-block;
}

.technology.colour-legend.red {
  background: #e89b87 !important;
}
.technology.colour-legend.yellow {
  background: #d3684b !important;
}
.technology.colour-legend.green {
  background: #cc4c2a !important;
}

.Human_Capital.colour-legend.red {
  background: #f1c250 !important;
}
.Human_Capital.colour-legend.yellow {
  background: #e8b539 !important;
}
.Human_Capital.colour-legend.green {
  background: #e2aa23 !important;
}

.Competitiveness.colour-legend.red {
  background: #89b982 !important;
}
.Competitiveness.colour-legend.yellow {
  background: #74b46c !important;
}
.Competitiveness.colour-legend.green {
  background: #66ad5d !important;
}

.colour-legend-container {
  background: #fafafa;
  margin: 2em 0 0 0;
  padding: 3em 0 1em 0;
}

.first-row {
  background-color: #f5f5f5;
}
</style>
